import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Nav from "@/components/Nav";
import Footer from "@/components/Footer";
import { api } from "@/lib/api";
import { MapPin } from "lucide-react";

export default function Regions() {
  const [regions, setRegions] = useState(null);

  useEffect(() => { api.regions().then(setRegions); }, []);

  return (
    <div className="App">
      <Nav />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <span className="label-eyebrow">Explore by region</span>
        <h1 className="font-display font-extrabold text-4xl sm:text-5xl mt-2" data-testid="regions-title">UK caravan park regions</h1>
        <p className="text-ink/70 mt-3 max-w-2xl">Tailor your holiday by coastline, countryside or city break. Click a region for our pick of the best parks.</p>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 mt-10">
          {!regions ? Array.from({ length: 9 }).map((_, i) => <div key={i} className="h-44 rounded-2xl skeleton-shimmer" />) :
            regions.map((r) => (
              <Link
                key={r.slug}
                to={`/region/${r.slug}`}
                className="group bg-white border border-border rounded-2xl p-6 hover:border-forest hover:shadow-md transition-all"
                data-testid={`regions-link-${r.slug}`}
              >
                <div className="flex items-center gap-2 text-ink/50 text-xs">
                  <MapPin className="w-3.5 h-3.5" /> United Kingdom
                </div>
                <h3 className="font-display font-bold text-2xl mt-2 group-hover:text-forest transition-colors">{r.name}</h3>
                <p className="text-sm text-ink/70 mt-2 line-clamp-3">{r.description}</p>
                <div className="text-xs text-forest font-medium mt-3">{r.count} parks →</div>
              </Link>
            ))}
        </div>
      </div>
      <Footer />
    </div>
  );
}
